<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t('extracurriculares.teachers_assistance.course_list') }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="courses"
        :search="search"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">
            <table border="0">
              <tbody>
                <template v-for="(schedule, rd) in props.item.active_schedules">
                  <tr v-if="schedules_id.includes(schedule.id)" :key="rd">
                    <td>{{ schedule.name }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </td>
          <td class="text-xs-center">
            <table border="0" width="100%">
              <tbody>
                <template v-for="(schedule, rd) in props.item.active_schedules">
                <tr v-if="schedules_id.includes(schedule.id)" :key="rd">
                  <td>
                    <v-layout row justify-center>
                      <v-btn
                      :disabled="!checkDay(schedule.course_id, schedule.id)"
                        color="primary"
                        @click="goToAssistance(schedule.course_id, schedule.id)"
                      >
                        {{ $t('extracurriculares.teachers_assistance.table.assistance') }}</v-btn>

                      <v-btn
                        color="secondary"
                        @click="exportAssistance(props.item.id, schedule.id)"
                        :loading="loadingDownlaod == props.item.id"
                      >
                        {{ $t('extracurriculares.teachers_assistance.table.download_today') }}
                      </v-btn>
                  </v-layout>
                  </td>
                </tr>
                </template>
              </tbody>
            </table>
          </td>
          <td v-if="loadingDownlaod == props.item.id">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="assistance_dialog"
      fullscreen scrollable
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="assistance_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ course_assistance.name }} - {{ schedule_assistance.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <assistance
          :course_id="this.course_assistance.id || 0"
          :schedule_id="this.schedule_assistance.id || 0"
          :course="this.course_assistance"
          :register_date="register_date_id_selected"
        ></assistance>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import assistance from './assistance'
  import excel from 'xlsx'
  export default {
    name: 'teachers-courses-view',
    components: {
      'assistance': assistance,
    },
    created () {
      this.init();
      this.getAssistance();
      this.getTodayName()
    },
    data() {
      return {
        schedule_assistance: {},
        assistance_dialog: false,
        dialog: false,
        courses: [],
        schedules_id: [],
        search: '',
        schedules_to_select: [],
        headers: [
          {
            text: this.$t('extracurriculares.teachers_assistance.table.course'),
            align: 'center',
            value: 'name'
          },
          {
            text: 'Horarios activos',
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('extracurriculares.teachers_assistance.table.actions'),
            align: 'center',
            value: 'actions'
          }
        ],
        headers_schedules: [
          {
            text: this.$t('extracurriculares.teachers_assistance.schedules_modal.schedule'),
            align: 'center',
            value: 'schedule'
          },
          {
            text: this.$t('extracurriculares.teachers_assistance.table.actions'),
            align: 'center',
            value: 'actions'
          }
        ],
        course_assistance: {},
        downloadableAssistance: [],
        jsonFields: {
          'Student': "student",
          'Assist': "assist",
          'Student Enrolled': "enrrolled"
        },
        loadingDownlaod: 0,
        today: '',
        register_date_id_selected: 0
      }
    },
    watch: {
      dialog(newValue, oldValue) {
        if(!newValue && oldValue) {
          this.getAssistance();
        }
      }
    },
    methods: {
      init() {
        axios.get('/api/extracurriculares/teacher/courses')
          .then(resp => {
            const { data } = resp
            if (resp.status === 200) {

              this.courses = data.courses
              this.schedules_id = data.schedules_id

            }
          })
          .catch(error => console.log(error))
      },
      getTodayName() {
        const days = [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ]
        const today = new Date()
        this.today = days[today.getDay()]
      },
      checkDay(course_id, schedule_id) {
        const course = this.courses.find(course => course.id === course_id)
        const schedules = course.schedules
          .filter(schedule => schedule.id === schedule_id)
          .filter(schedule =>
            schedule.details.filter(detail => detail.day === this.today).length > 0).length > 0
            
          return schedules
      },
      goToAssistance(course_id, schedule_id) {
        const course = this.courses.find(course => course.id === course_id)
        const schedule = course.schedules.find(schedule => schedule.id === schedule_id)
        this.course_assistance = course
        this.schedule_assistance = schedule
        this.assistance_dialog = true
      },
      async getAssistance() {
        const resp = await axios.get(`/api/extracurriculares/assistance/course`)
        this.downloadableAssistance = resp.data
      },
      exportAssistance(course_id, register_date_id) {
        const assistance = this.downloadableAssistance
          .filter(assist => assist.course_id === course_id)
          .filter(assist => assist.course_register_dates_id == register_date_id)
          // .forEach(assist => delete assist.course_id)
        this.loadingDownlaod = course_id
        if (assistance.length === 0) {
          this.$store.dispatch('responseMessage', {
            type: 'warning',
            text: 'No hay registros para descargar',
            modal: false
          })
          this.loadingDownlaod = 0
          return
        }

        // const headers = {
        //   skipHeader: true,
        //   origin: "A2",
        //   header: [
        //     this.$t('extracurriculares.teachers_assistance.export.course_id'),
        //     this.$t('extracurriculares.teachers_assistance.export.schedule'),
        //     this.$t('extracurriculares.teachers_assistance.export.student'),
        //     this.$t('extracurriculares.teachers_assistance.export.assist'),
        //     this.$t('extracurriculares.teachers_assistance.export.enrrolled'),
        //     this.$t('extracurriculares.teachers_assistance.export.notes'),
        //   ],
        // }

        const assistToExport = excel.utils.json_to_sheet(assistance)

        // A workbook is the name given to an Excel file
        const wb = excel.utils.book_new() // make Workbook of Excel

        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        excel.utils.book_append_sheet(wb, assistToExport, 'Assistance') // sheetAName is name of Worksheet

        // export Excel file
        excel.writeFile(wb, 'assistance.xlsx') // name of the file is 'book.xlsx'
        this.loadingDownlaod = 0
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/teacher/courses.vue